/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { consentreference } from '../domain/consentreference';
import { connectionparameters } from 'projects/icemedx-lib/src/models/messages/connectionparameters';
import { observation } from 'projects/icemedx-lib/src/models/ehr/subs/observation';
import { managementguideline } from 'projects/icemedx-lib/src/models/ehr/subs/managementguideline';
import { externaldata } from 'projects/icemedx-lib/src/models/ehr/externaldata';

export class message extends IceEntity {
  message_key: string = "";
  parent_message_key: string = "";
  message_date: any = NaN;
  message_status: IceTypes.trans_status = IceTypes.trans_status.isNone;
  trans_account: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  from: string = "";
  to: string = "";
  cc: string = "";
  bcc: string = "";
  subject: string = "";
  message_body: string = "";
  trans_type: IceTypes.TRANSTYPE = IceTypes.TRANSTYPE.itNone;
  blog: boolean = false;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";
  requested_access_trans_account: string = "";
  requested_access_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  requested_access_country_id: string = "";

  CONSENTS: consentreference[] = [];
  SENDERS: connectionparameters[] = [];
  RECEIVERS: connectionparameters[] = [];
  GLRULES: managementguideline[] = [];
  ATTACHMENTS: externaldata[] = [];

  gettablename(): string {
        return "MESSAGE";
    }

    hassubtree(ColumnName: string): boolean {
      if (ColumnName.length == 0) return false;
      else if (ColumnName == "CLMS") return true;
      else if (ColumnName == "SUBS") return true;
      else if (ColumnName == "TTYPES") return true;
      else if (ColumnName == "SENDERS") return true;
      else if (ColumnName == "RECEIVERS") return true;
      else if (ColumnName == "CONSENTS") return true;
      else if (ColumnName == "INVITETYPES") return true;
      else if (ColumnName == "INVITEACCESS") return true;
      else if (ColumnName == "GLRULES") return true;
      else if (ColumnName == "ATTACHMENTS") return true;

      return false;
    }

    getsubtreetablename(ColumnName: string): string {
      if (ColumnName.length == 0) return null;
      else if (ColumnName == "CLMS") return "CLAIM";
      else if (ColumnName == "SUBS") return "SUBSCRIBER";
      else if (ColumnName == "TTYPES") return "TRANS_TYPE_REFERENCE";
      else if (ColumnName == "SENDERS") return "CONNECTION_PARAMETERS";
      else if (ColumnName == "RECEIVERS") return "CONNECTION_PARAMETERS";
      else if (ColumnName == "CONSENTS") return "CONSENT_REFERENCE";
      else if (ColumnName == "INVITETYPES") return "TRANS_ACCOUNT_REFERENCE";
      else if (ColumnName == "INVITEACCESS") return "TRANS_ACCOUNT_PERMISSION";
      else if (ColumnName == "GLRULES") return "MANAGEMENT_GUIDELINE";
      else if (ColumnName == "ATTACHMENTS") return "EXTERNAL_DATA";

      return null;
    }
}
